const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

let storefront_API = '51ac5a47f154e38d6d03b7a1c2b4f605'
switch (window.location.hostname) {
  case '127.0.0.1':
  case 'beta-lepro.myshopify.com':
    storefront_API = 'ee43c8828ac4cec1549a45f6f6bb7804'
    break;
  case 'lepro-store-checkout-test.myshopify.com':
    storefront_API = '049f33e4732f456599b566fc9c736ab3'
    break;
}

window.ShopifyConstant = {
  endpoint: '/api/2025-07/graphql.json', // storefront API 使用的异步接口
  storefront_API: storefront_API,
  multipassToken: '_mt_t', // token 的key
  E_164: '+1', // 手机国际区号 snippets\lepro-customer-profile.liquid文件也有使用到
  logoutLink: '/account/logout',
  currentSymbol: {
    'CAD': 'CA $'
  },
  getCookie(name) { // 获取cookie
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
      const newToken = parts.pop().split(';').shift()
      return newToken
    };
    return null;
  },
  deleteCookie(key) {
    document.cookie = key + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
  },
  copyTextFallback(text, fn = () => {}) {
    navigator.clipboard.writeText(text).then(() => {
      fn()
    }).catch(err => {
    })
  },

  // 跳转到支付页面
  linkCheckoutPage() {
    window.location.href = '/checkout'
  },

  formatMoney(amount = 0, fixed = 2) { // 格式化数字 amount：需要格式化的数，fixed：保留的小数;变为 6,666 的格式价格
    if(!amount) {
      amount = 0
    }
    return (Math.ceil(parseFloat(amount) * 100) / 100).toFixed(fixed).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  },
  // 把时间转为多伦多时间
  formatterTime (date) {
    const parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'America/Toronto', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
    }).formatToParts(date)
    const part = type => parts.find(item => item.type === type).value
    return `${part('year')}-${part('month')}-${part('day')}T${part('hour')}:${part('minute')}:${part('second')}`
  },

  /**
   * 价格逻辑 和 snippets\lepro-price.liquid 组件的价格逻辑一致
   * @param {*} variantProduct 变体产品信息
   * @param {*} metafields 变体的元字段 variantProduct.metafields?.custom
   * @returns 
   */
  renderPrice(variantProduct, metafields) {
    let text = ''

    const currencySymbol = this.currentSymbol[window.Shopify?.currency?.active] || ''

    // B2B Catalog: compare_at_price > price → skip metafield discount
    if (window.isB2BCustomer && variantProduct.compare_at_price && variantProduct.compare_at_price > variantProduct.price) {
      text = `<span class="price-sale bold">${currencySymbol}${this.formatMoney(variantProduct.price / 100)}</span>
      <span class="price-regular">${currencySymbol}${this.formatMoney(variantProduct.compare_at_price / 100)}</span>
      `
      return text
    }

    const discount = window.isB2BCustomer ? null : metafields?.variants_discounts_and_marketing?.product_detail_max_discount?.discount
    if (discount && discount.amount?.amount) {
      const amount = discount.amount.amount * 100
      const priceSale = variantProduct.price - amount
      text = `<span class="price-sale bold">${currencySymbol}${this.formatMoney(priceSale / 100)}</span>
      <span class="price-regular">${currencySymbol}${this.formatMoney(variantProduct.price / 100)}</span>
      `
    } else if (discount && discount.percentage) {
      const amountString = (variantProduct.price / 100).toFixed(4)
      const percentage = Math.ceil((1 - discount.percentage) * amountString * 100)
      text = `<span class="price-sale bold">${currencySymbol}${this.formatMoney(percentage / 100)}</span>
      <span class="price-regular">${currencySymbol}${this.formatMoney(variantProduct.price / 100)}</span>
      `
    } else {
      text = `<span class="price-sale bold">${currencySymbol}${this.formatMoney(variantProduct.price / 100)}</span>`
    }

    return text
  },

  /**
   * 折扣tag 和 snippets\lepro-price.liquid 组件的价格逻辑一致
   * @param {*} metafields 变体的元字段 variantProduct.metafields?.custom
   * @returns 
   */
  renderOffPrice(metafields, variantProduct) {
    let text = ''

    // B2B Catalog: compare_at_price > price，用实际价差计算折扣百分比
    if (window.isB2BCustomer && variantProduct?.compare_at_price > variantProduct?.price) {
      const pct = Math.round((variantProduct.compare_at_price - variantProduct.price) / variantProduct.compare_at_price * 100)
      text = `<span class="lepro-code-num bold" background="https://cdn.shopify.com/s/files/1/0687/7980/2669/files/lepro-icon_off.png?v=1753838407">${pct}%<br>Off</span>`
      return text
    }

    const currencySymbol = this.currentSymbol[window.Shopify?.currency?.active] || ''
    const discount = window.isB2BCustomer ? null : metafields?.variants_discounts_and_marketing?.product_detail_max_discount?.discount
    if (discount) {
      if (discount.amount?.amountString) {
        text = `<span class="lepro-code-num bold" background="https://cdn.shopify.com/s/files/1/0687/7980/2669/files/lepro-icon_off.png?v=1753838407">${currencySymbol}${discount.amount.amountString}<br>Off</span>`
      } else if (discount.percentage) {
        const percentage = discount.percentage * 100
        text = `<span class="lepro-code-num bold" background="https://cdn.shopify.com/s/files/1/0687/7980/2669/files/lepro-icon_off.png?v=1753838407">${Math.floor(percentage)}%<br>Off</span>`
      }
    }

    return text
  },

  // 返回日期
  // Apply product coupons to the current Ajax cart and verify acceptance.
  async applyCartDiscountCodes(coupons) {
    if (window.isB2BCustomer) return;
    const requestedCodes = [...new Set(coupons.flatMap(code => (code || '').split(','))
      .map(code => code.trim()).filter(Boolean))];
    if (!requestedCodes.length) return;
    const cartResponse = await fetch('/cart.json');
    if (!cartResponse.ok) throw new Error('Unable to read cart for discount');
    const cart = await cartResponse.json();
    if (!cart.token) throw new Error('Missing cart token');
    const existingCodes = (cart.discount_codes || []).filter(code => code.applicable).map(code => code.code);
    const discountCodes = [...new Set([...requestedCodes, ...existingCodes])];
    let accessToken = this.storefront_API;
    const features = document.querySelector('#shopify-features');
    if (features?.textContent) {
      accessToken = JSON.parse(features.textContent).accessToken || accessToken;
    }
    const response = await fetch(this.endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': accessToken
      },
      body: JSON.stringify({
        query: `mutation cartDiscountCodesUpdate($cartId: ID!, $discountCodes: [String!]!) {
          cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
            cart { discountCodes { code applicable } }
            userErrors { field message }
          }
        }`,
        variables: { cartId: `gid://shopify/Cart/${cart.token}`, discountCodes }
      })
    });
    const result = await response.json();
    const update = result.data?.cartDiscountCodesUpdate;
    const errors = [...(result.errors || []), ...(update?.userErrors || [])];
    if (!response.ok || errors.length || !update?.cart) {
      throw new Error(errors.map(error => error.message).join('; ') || 'Unable to apply discount');
    }
    const appliedCodes = update.cart.discountCodes || [];
    if (requestedCodes.some(code => !appliedCodes.some(applied =>
      applied.applicable && applied.code.toLowerCase() === code.toLowerCase()))) {
      throw new Error('Product discount is not applicable to this cart');
    }
  },

  reportCartDiscountError(error) {
    console.error('[cart-discount]', error);
    this.messageTip('Item added, but the discount could not be applied. Please check your cart before checkout.', 'error');
  },

  // Format date for display.
  formatDate(date = new Date(), isSplice = true) {
    const formatter = new Date(this.formatterTime(date))

    const year = formatter.getFullYear()
    const month = String(formatter.getMonth() + 1).padStart(2, '0')
    const day = String(formatter.getDate()).padStart(2, '0')
    const hour = String(formatter.getHours()).padStart(2, '0')
    const minute = String(formatter.getMinutes()).padStart(2, '0')
    const second = String(formatter.getSeconds()).padStart(2, '0')
    if (!isSplice) {
      return {
        year,
        month,
        day,
        hour,
        minute,
        second
      }
    }
    return `${year}-${month}-${day} ${hour}:${minute}:${second}`
  },
  // 通过时间戳返回 天、时、分、秒
  combinationNode (timestamp = 0) {
    let seconds = Math.floor(timestamp / 1000)
    const days = Math.floor(seconds / (24 * 3600))
    seconds %= 24 * 3600
    const hours = Math.floor(seconds / 3600)
    seconds %= 3600
    const minutes = Math.floor(seconds / 60)
    seconds %= 60

    const dd = String(days).padStart(2, '0');
    const hh = String(hours).padStart(2, '0');
    const mm = String(minutes).padStart(2, '0');
    const ss = String(seconds).padStart(2, '0');

    return {
      dd,
      hh,
      mm,
      ss
    }
  },
  getMt_t(_mt, errText = 'Request Filed') { // 获取 multipass token，用于用户登录成功后调用接口需要用到的token
    const queryData = `
      mutation customerAccessTokenCreateWithMultipass($multipassToken: String!) {
        customerAccessTokenCreateWithMultipass(multipassToken: $multipassToken) {
          customerAccessToken {
            accessToken
            expiresAt
          }
          customerUserErrors {
            code
            message
          }
        }
      }`
    const variables = {
      multipassToken: _mt
    }
    
    return new Promise((resolve, reject) => {
      fetch(window.ShopifyConstant.endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': window.ShopifyConstant.storefront_API
        },
        body: JSON.stringify({
          query: queryData,
          variables: variables
        })
      }).then((response) => response.json())
      .then((res) => {
        if (res.data?.customerAccessTokenCreateWithMultipass?.customerAccessToken) {
          const accessToken = res.data.customerAccessTokenCreateWithMultipass.customerAccessToken.accessToken
          const expiresAt = res.data.customerAccessTokenCreateWithMultipass.customerAccessToken.expiresAt
          document.cookie = window.ShopifyConstant.multipassToken + "=" + accessToken + ";expires=" + expiresAt + ";path=/"
          resolve()
        } else {
          reject(errText)
        }
      }).catch((error) => {
        reject(errText)
      })
    })
  },
  getErrorNode(msg = 'Request Filed') { // 表单的错误提示
    let errorHtml = ''
    if (msg && Array.isArray(msg)) {
      msg.forEach(item => {
        errorHtml += `<li>${item.message}</li>`
      })
    } else if (msg && typeof msg == 'object') {
      for (const key in msg) {
        errorHtml += `<li>${msg[key]}</li>`
      }
    } else {
      errorHtml += `<li>${msg}</li>`
    }
    return errorHtml
  },
  // 设置折扣价格
  setDiscountPrice(price = 0, discount, fixed = 2) {
    let discountPrice = price / 100
    if (discount) {
      if (discount.amount?.amount) { // 折扣具体价格
        discountPrice = parseFloat(discountPrice) - parseFloat(discount.amount.amount)
      } else if (discount.percentage) { // 折扣百分比
        discountPrice = parseFloat(discountPrice) * (1 - parseFloat(discount.percentage))
      }
    }

    return (Math.ceil(parseFloat(discountPrice) * 100) / 100).toFixed(fixed)
  },

  // 节流方法
  rafThrottle(fn, delay = 200) {
    let last = 0
    return function (...args) {
      const now = Date.now()
      if (now - last >= delay) {
        fn.apply(this, args)
        last = now;
      }
    }
  },

  // 判断当前时间和结束时间是否小于7天
  lessThanDay_7(endAt, currentDate = new Date()) {
    if (!endAt) {
      return false
    }
    
    const currentTime = new Date(this.formatterTime(currentDate)).getTime()
    const endTime = new Date(endAt.replace('Z', '')).getTime()

    const timeStamp = 24 * 60 * 60 * 1000 * 7

    const poorTimeStamp = endTime - currentTime

    if (poorTimeStamp < timeStamp && poorTimeStamp > 0) {
      return poorTimeStamp
    }
  
    return false
  },

  // 异步设置商品详情弹窗
  setProductDialog(bundle, variant, type) {
    const url = `/products/${bundle}?section_id=lepro-product-view-dialog${variant ? `&variant=${variant}` : ''}`
    fetch(url)
      .then((response) => response.text())
      .then((res) => {
        let text = res

        let parser = new DOMParser()
        let doc = parser.parseFromString(text, "text/html")

        if (type) {
          doc.body.querySelector('le-product-dialog').setAttribute('data-theme', type)
        }

        const leProductDialog = doc.body.querySelector('le-product-dialog').outerHTML

        const newDiv = document.createElement("div")
        newDiv.innerHTML = leProductDialog
        document.body.appendChild(newDiv)

        document.body.classList.add('overflow-hidden')
      })
      .catch((err) => {
        console.error('err', err);
      })
  },

  // 判断是否有底部悬浮的购物车信息，如果有更新悬浮购物车信息
  updateFixedCartInfo() {
    const cartInfoNode = document.querySelector('[fixed-cart-page]')
    if (cartInfoNode) {
      const sectionId = cartInfoNode.getAttribute('section-id')
      const url = `/?section_id=${sectionId}`
      fetch(url)
        .then((response) => response.text())
        .then((res) => {
          let text = res

          let parser = new DOMParser()
          let doc = parser.parseFromString(text, "text/html")

          const fixedCartNode = doc.body.querySelector('[fixed-cart-page]').outerHTML

          cartInfoNode.outerHTML = fixedCartNode

        })
        .catch((err) => {
          console.error('err', err);
        })
    }
  },

  /**
   * 消息提示
   * @param {*} msg 
   * @param {*} type error, info, success, warning
   * 暂时只有 error 和 默认
   */
  messageTip(msg, type = 'info', delay = 3000, animiDelay = 300) {
    const messages = document.querySelectorAll('.le-message-info')

    let zIndex = 10000

    if (messages && messages.length) {
      zIndex += zIndex + messages.length * 10
    }

    const info = `<div class="le-message-info ${type}" style="z-index: ${zIndex}">
      <div class="message_body">
        <div class="message_icon"></div>
        <div class="message_content">${ msg }</div>
      </div>
    </div>`

    const newDiv = document.createElement("div")
    newDiv.innerHTML = info
    document.body.appendChild(newDiv)

    const showTimer = setTimeout(() => {
      newDiv.querySelector('.le-message-info').classList.add('show')
      clearTimeout(showTimer)
    }, 10)

    const hideTimer = setTimeout(() => {
      newDiv.querySelector('.le-message-info').classList.remove('show')
      clearTimeout(hideTimer)
      
      const removeTimer = setTimeout(() => {
        newDiv.remove()
        clearTimeout(removeTimer)
      }, animiDelay)
    }, delay)
  }
}